export const NationalityGroupOptions = [
  { value: "Egyptian", label: "Egyptian" },
  { value: "Arab", label: "Arab" },
  { value: "Other", label: "Other" },
];

export const GenderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const UserTypesArray = [
  { value: "Admin", label: "Admin" },
  { value: "Owner", label: "Owner" },
  { value: "HeadAccounting", label: "Head Accounting" },
  { value: "SubAdmin", label: "Sub Admin" },
  { value: "AppointmentEmployee", label: "Appointment Employee" },
  { value: "CallCenterEmployee", label: "Call Center Employee" },
  { value: "AccountingEmployee", label: "Accounting Employee" },
  { value: "Therapist", label: "Therapist" },
  { value: "FloorManager", label: "Floor Manager" },
  { value: "Patient", label: "Patient" },
];
